import { FormattedMessage } from 'react-intl';
import React from 'react';
import bemify from 'bemify-js';

import Code from '../components/Code';
import Paragraph from '../components/Paragraph';
import StepTitle from '../components/StepTitle';
import SyntaxHighlighter from '../components/SyntaxHighlighter';

const bem = bemify('index-js-file');

const jsCodeBlock = `const repoTrigger = require('./triggers/repo');
const issueCreate = require('./creates/issue');
const issueTrigger = require('./triggers/issue');
const authentication = require('./authentication');

const handleHTTPError = (response, z) => {
  if (response.status >= 400) {
    throw new Error(\`Unexpected status code \${response.status}\`);
  }
  return response;
};

const App = {
  // This is just shorthand to reference the installed dependencies
  // you have. Zapier will need to know these before we can upload!
  version: require('./package.json').version,
  platformVersion: require('zapier-platform-core').version,
  authentication: authentication,

  // beforeRequest & afterResponse are optional hooks into the
  // provided HTTP client
  beforeRequest: [
  ],

  afterResponse: [
    handleHTTPError
  ],

  // If you want to define optional resources to simplify
  // creation of triggers,  searches, creates - do that here!
  resources: {
  },

  triggers: {
    [repoTrigger.key]: repoTrigger,
    [issueTrigger.key]: issueTrigger,
  },

  searches: {
  },

  creates: {
    [issueCreate.key]: issueCreate,
  }
};

// Finally, export the app.
module.exports = App;
`;

const IndexJSFile = () => (
  <div className={bem()}>
    <StepTitle>
      <FormattedMessage
        defaultMessage="Explore the Project: The Index.js File"
        id="headings-explore-project-index-js-file"
      />
    </StepTitle>
    <Paragraph>
      <FormattedMessage
        defaultMessage="The"
        id="descriptions-index-js-file-overview-prefix"
      />{' '}
      <Code>index.js</Code>{' '}
      <FormattedMessage
        defaultMessage="file contains the application definition for your app."
        id="descriptions-index-js-file-overview-suffix"
      />
    </Paragraph>
    <SyntaxHighlighter language="javascript">{jsCodeBlock}</SyntaxHighlighter>
    <Paragraph>
      <Code>index.js</Code>{' '}
      <FormattedMessage
        defaultMessage={
          'brings together all your code and tells the Zapier platform how users will authenticate with your API, how to get data from your API into a Zap ("triggers", "searches"), how to get data from a Zap to your API ("creates"), as well as stuff you want to do before or after every request, and app metadata.'
        }
        id="descriptions-index-js-file-purpose-and-platform-behavior"
      />
    </Paragraph>
  </div>
);

export default IndexJSFile;
